<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    @click:outside="cancel"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
  >
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>{{ type === 'update' ? 'SỬA HỒ SƠ XE' : 'THÊM HỒ SƠ XE' }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" class="pt-6">
          <h3 class="mb-2">1. Thông tin cơ bản</h3>
          <InfoBasicForm ref="infoBasicForm" :oldData="oldData" />
          <h3 class="mb-2">2. Thông tin xe</h3>
          <BusForm ref="busForm" :oldData="oldData" />
          <h3 class="mb-2">3. Thông tin tài xế</h3>
          <DriverFrom ref="driverForm" :oldData="oldData" />
          <v-row>
            <v-col cols="12">
              <v-textarea outlined full-width no-resize placeholder="Ghi chú" v-model="note" dense></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save" width="100px">XÁC NHẬN</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import InfoBasicForm from './DialogBusInfo/InfoBasicForm.vue'
import DriverFrom from './DialogBusInfo/DriverFrom.vue'
import BusForm from './DialogBusInfo/BusForm.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    InfoBasicForm,
    DriverFrom,
    BusForm
  },
  data() {
    return {
      oldData: null,
      dialog: false,
      note: '',
      type: ''
    }
  },
  methods: {
    ...mapActions({
      update: 'busInformation/update',
      create: 'busInformation/create',
      fetch: 'busInformation/fetch',
      count: 'busInformation/count'
    }),

    openDialog(type, item) {
      if (type === 'update') this.oldData = item
      this.type = type
      this.dialog = true
    },

    cancel() {
      this.dialog = false
      this.oldData = null
      this.note = ''
    },

    async save() {
      try {
        if (!this.$refs.form.validate()) return this.$alert.error('Vui lòng nhập đầy đủ thông tin')
        this.$loading.active = true
        const infoBasic = this.$refs.infoBasicForm.getData()
        if (infoBasic === undefined) return this.$alert.error('Vui lòng kiểm tra mục 1.Thông tin cơ bản')

        const infoCar = this.$refs.busForm.getData()
        if (infoCar === undefined) return this.$alert.error('Vui lòng kiểm tra mục 2.Thông tin xe')

        const driver = this.$refs.driverForm.getData()
        if (driver === undefined) return this.$alert.error('Vui lòng kiểm tra mục 3.Thông tin tài xế')

        const data = { ...infoBasic, ...infoCar, ...driver, note: this.note }
        if (this.type === 'update') await this.update({ ...data, id: this.oldData.id })
        else await this.create(data)
        this.$alert.success('Thành công')
        this.fetch({})
        this.count({})
        this.dialog = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
